<template>
  <div>
    <div>
      <!-- Header Area -->
      <header class="main_header_area mha_2"></header>
      <!-- Header Area -->
      <vue-headful
        title="Credimóvil | Contrato Credito"
        :head="{
          'meta[charset]': { charset: 'utf-8' }
        }"
      />
      <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud>
    </div>

    <section class="banner_area banner_area_8"></section>
    <!-- Banner Area -->
    <div class="container">
      <div class="d-flex justify-content-center row p-3">
        <button type="button" @click="generatePDF()" class="btn btn-success">
          Generar PDF
        </button>
      </div>
      <div id="page1-div" ref="document" class="container interline">
        <v-formato-gps v-bind:data="data"></v-formato-gps>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import datosFacturacion from "./Caratura1/DatosFacturacion.vue";
import formatoGps from "./Caratura1/FormatoGps.vue";
import Environments from "../../environments/Environment";
import moment from "moment";

let now = new Date();
var meses = new Array(
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
);

export default {
  name: "Caratura1",
  data() {
    return {
      acepted: false,
      datos_facturacion: false,
      clickupId: "",
      data: {
        tipoAval: true,
        tipoClasico: false,
        tipoObligado: false,
        tipoObligadoAval: false,
        showMarca: true,
        telefono: "telefono",
        nombre_cliente: "nombre_cliente",
        correo: "correo",
        genero: "genero",
        CURP: "CURP",
        estado_civil: "estado_civil",
        fecha_nacimiento: "fecha_nacimiento",
        edad: "edad",
        estado_cliente: "estado_cliente",
        municipio_cliente: "municipio_cliente",
        colonia_cliente: "colonia_cliente",
        numero_calle_cliente: "numero_calle_cliente",
        codigo_postal_cliente: "codigo_postal_cliente",
        calle_cliente: "calle_cliente",
        estatus_vivienda_cliente: "estatus_vivienda_cliente",
        vivienda_desde: "vivienda_desde",
        numero_cheque: "numero_cheque",
        fecha_contrato:
          now.getDate() +
          1 +
          " de " +
          meses[now.getMonth()] +
          " del " +
          now.getFullYear(),

        plazo: "plazo",
        monto_a_finaciar: "monto_a_finaciar",
        monto_a_finaciar_letra: "monto_a_finaciar_letra",
        mensualidad: "mensualidad",
        mensualidad_letra: "mensualidad_letra",
        monto_total: "monto_total",
        monto_total_letra: "monto_total_letra",
        precio_vehiculo: "precio_vehiculo",
        engache: "engache",

        tipo_vehiculo: "tipo_vehiculo",
        marca_vehiculo: "marca_vehiculo",
        modelo_vehiculo: "modelo_vehiculo",
        año_vehiculo: "año_vehiculo",
        seguro_vehiculo: "seguro_vehiculo",

        tasa_ordinaria: "00.00",
        moratorio: 8.0,
        moratorio_letra: "ECHO PORCIENTO",
        cat_anual: 56.4,

        nombre_empresa: "nombre_empresa",
        situcion_empleo: "situcion_empleo",
        sector_empleo: "sector_empleo",

        ingreso_mensual: "ingreso_mensual",
        ingreso_variable: "ingreso_variable",
        ingreso_otro: "ingreso_otro",
        ingreso_familiar: "ingreso_familiar",

        nombre_referecnia_1: "nombre_referecnia_1",
        telefono_referecnia_1: "telefono_referecnia_1",
        tipo_referecnia_1: "tipo_referecnia_1",
        nombre_referecnia_2: "nombre_referecnia_2",
        telefono_referecnia_2: "telefono_referecnia_2",
        tipo_referecnia_2: "tipo_referecnia_2",
        nombre_referecnia_3: "nombre_referecnia_3",
        telefono_referecnia_3: "telefono_referecnia_3",
        tipo_referecnia_3: "tipo_referecnia_3",

        banco: "BANORTE",
        cuenta_banco: "0420253088",
        clave_banco: "072320004202530888",

        año_contrato: now.getFullYear(),

        nombre_aval: "nombre_aval",
        nombre_obligado: "nombre_obligado",

        seguro_nombre: "seguro_nombre",
        seguro_covertura: "seguro_covertura",
        precio_seguro: "precio_seguro",
        numero_serie_vehiculo: "numero_serie_vehiculo",
        numero_motor_vehiculo: "numero_motor_vehiculo",
        placa_vehiculo: "placa_vehiculo",
        numero_factura: "numero_factura",
        fecha_factura: "xx xx fecha_factura x",
        emisor_factura: "emisor_factura",

        //TODO:estatos aun no los tenemos
        periodicidad: "MENSUAL",
        monto_finaciar_sin_seguro: "monto_finaciar_sin_seguro",
        valor_comercial_vehiculo: "valor_comercial_vehiculo",

        fecha_primer_pago: "10 DE FEBRERO DE 2023",
        fecha_ultimo_pago: "10 de FEBRERO DE 2025",
        dias_de_abono: "10",

        referencia_banco: "referencia_banco",
        No_Operacion_Cliente: "No_Operacion_Cliente",
        Deeler: "CARLOS BOBADILLA"
      }
    };
  },
  validations() {
    return {};
  },
  components: {
    "v-datos-facturacion": datosFacturacion,
    "v-formato-gps": formatoGps
  },
  methods: {
    generatePDF() {
      this.preloader();
      this.data.showMarca = false;
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "FORMATO_GPS" + this.data.nombre_cliente + ".pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 2,
          dpi: 196,
          letterRendering: true,
          useCORS: true
        },
        jsPDF: { unit: "mm", format: "A4", orientation: "p" }
      }).then(result => {
        this.data.showMarca = true;
        this.preloaderHiden();
      });
    },
    getUser() {
      this.$UserService.getUser().then(
        result => {
          if (result.data.length > 0) {
            this.clickupId = result.data[0].clickup_task;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserAval() {
      this.$UserService.getUserAval().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_aval = result.data[0].last_name
              ? result.data[0].first_name +
                " " +
                result.data[0].father_name +
                " " +
                result.data[0].mother_name
              : result.data[0].first_name +
                " " +
                result.data[0].last_name +
                " " +
                result.data[0].father_name +
                " " +
                result.data[0].mother_name;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserObligado() {
      this.$UserService.getUserObligado().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_obligado = result.data[0].last_name
              ? result.data[0].first_name +
                " " +
                result.data[0].father_name +
                " " +
                result.data[0].mother_name
              : result.data[0].first_name +
                " " +
                result.data[0].last_name +
                " " +
                result.data[0].father_name +
                " " +
                result.data[0].mother_name;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserDetaill() {
      this.$UserService.getDetails().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_cliente = result.data[0].last_name
              ? result.data[0].first_name +
                " " +
                result.data[0].father_name +
                " " +
                result.data[0].mother_name
              : result.data[0].first_name +
                " " +
                result.data[0].last_name +
                " " +
                result.data[0].father_name +
                " " +
                result.data[0].mother_name;
            this.data.nombre_cliente = this.data.nombre_cliente.toUpperCase();
            this.data.fecha_nacimiento = moment(
              result.data[0].DOB,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
            //this.data.estado_cliente = result.data[0].state_dob;

            this.data.estado_civil = result.data[0].marital_status.toUpperCase();
            this.data.CURP = result.data[0].CURP.toUpperCase();
            this.data.genero = result.data[0].gender.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserAddress() {
      this.$UserService.getAddress().then(
        result => {
          if (result.data.length > 0) {
            this.data.calle_cliente = result.data[0].street.toUpperCase();
            this.data.numero_calle_cliente = result.data[0].address_no.toUpperCase();
            this.data.estado_cliente = result.data[0].state.toUpperCase();
            this.data.municipio_cliente = result.data[0].town.toUpperCase();
            this.data.colonia_cliente = result.data[0].suburb.toUpperCase();
            this.data.codigo_postal_cliente = result.data[0].postcode.toUpperCase();

            this.data.vivienda_desde = result.data[0].living_since.toUpperCase();
            this.data.estatus_vivienda_cliente = result.data[0].current_living.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getQuotation() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.data.precio_vehiculo = result.data[0].vehicle_price;
            this.data.enganche = result.data[0].vehicle_hitch;
            this.data.monto_a_finaciar = result.data[0].requested_amount_credit;

            this.data.plazo = result.data[0].months;
            this.data.tasa_ordinaria = (
              Environments.TASA * this.data.plazo
            ).toFixed(2);
            this.data.monto_total =
              this.data.monto_a_finaciar +
              this.data.monto_a_finaciar * (this.data.tasa_ordinaria / 100);
            this.data.mensualidad = (
              this.data.monto_total / this.data.plazo
            ).toFixed(2);
            this.data.tipo_vehiculo = result.data[0].vehicle_type.toUpperCase();
            this.data.marca_vehiculo = result.data[0].vehicle_brand.toUpperCase();
            this.data.modelo_vehiculo = result.data[0].vehicle_model.toUpperCase();
            this.data.año_vehiculo = result.data[0].vehicle_version.toUpperCase();
            this.data.seguro_vehiculo = result.data[0].insurance_payment.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getEmployement() {
      this.$UserService.getEmployement().then(
        result => {
          if (result.data.length > 0) {
            this.data.ingreso_mensual = result.data[0].net_income;
            this.data.ingreso_variable = result.data[0].verifiable_income;
            this.data.ingreso_familiar = result.data[0].family_income;
            this.data.verifiable_income = result.data[0].unverifiable_income;

            this.data.nombre_empresa = result.data[0].company_name;
            this.data.situcion_empleo = result.data[0].employment_situation;
            this.data.sector_empleo = result.data[0].line_of_business;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getReference() {
      this.$UserService.getReference().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_referecnia_1 = result.data[0].name;
            this.data.telefono_referecnia_1 = result.data[0].phone;
            this.data.tipo_referecnia_1 = result.data[0].type;
          }
          if (result.data.length >= 2) {
            this.data.nombre_referecnia_2 = result.data[1].name;
            this.data.telefono_referecnia_2 = result.data[1].phone;
            this.data.tipo_referecnia_2 = result.data[1].type;
          }
          if (result.data.length >= 3) {
            this.data.nombre_referecnia_3 = result.data[2].name;
            this.data.telefono_referecnia_3 = result.data[2].phone;
            this.data.tipo_referecnia_3 = result.data[2].type;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getInsurce() {
      this.$InsuranceService.getInsurce().then(
        result => {
          if (result.data.length > 0) {
            this.data.seguro_nombre = result.data[0].insurce_name;
            this.data.seguro_covertura = result.data[0].insurance_coverage;
            this.data.precio_seguro = result.data[0].insurce_price;
            this.data.numero_serie_vehiculo =
              result.data[0].serial_number_vehicle;
            this.data.numero_motor_vehiculo =
              result.data[0].engine_number_vehicle;
            this.data.placa_vehiculo = result.data[0].car_license_plates;
            this.data.numero_factura = result.data[0].invoice_number;
            this.data.emisor_factura = result.data[0].invoice_issuer;

            let fecha_factura = new Date(result.data[0].invoice_date);
            this.data.fecha_factura =
              fecha_factura.getDate() +
                1 +
                " de " +
                meses[fecha_factura.getMonth()] +
                " del " +
                fecha_factura.getFullYear() || "FECHA FACTURA NO ASIGNADA";
          }
        },
        err => {
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getContract() {
      this.$UserService.getContract().then(
        result => {
          if (result.data.length > 0) {
            this.data.referencia_banco = result.data[0].referencia_banco;
            this.data.No_Operacion_Cliente = result.data[0].numero_operacion;
            this.data.valor_comercial_vehiculo =
              result.data[0].valor_comercial_vehiculo;
            let fecha_primer_pago = new Date(
              result.data[0].fecha_primer_pago
            );
            let fecha_ultimo_pago = new Date(result.data[0].fecha_ultimo_pago);
            this.data.dias_de_abono = result.data[0].dia_pago;
            this.data.periodicidad = result.data[0].frecuencia;
            this.data.fecha_primer_pago =
              fecha_primer_pago.getDate() +
                1 +
                " de " +
                meses[fecha_primer_pago.getMonth()] +
                " del " +
                fecha_primer_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";

            this.data.fecha_ultimo_pago =
              fecha_ultimo_pago.getDate() +
                1 +
                " de " +
                meses[fecha_ultimo_pago.getMonth()] +
                " del " +
                fecha_ultimo_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";
          }
        },
        err => {
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getNumberLetter() {
      this.$UtilityService
        .NumeroALetras(this.data.mensualidad, {})
        .then(result => {
          this.data.mensualidad_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_total, {})
        .then(result => {
          this.data.monto_total_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_a_finaciar, {})
        .then(result => {
          this.data.monto_a_finaciar_letra = result;
        });
    },
    fillData() {
      this.getUserDetaill();
      this.getUserAddress();
      this.getContract();
      this.getQuotation();
      this.getEmployement();
      this.getReference();
      this.getUserObligado();
      this.getUserAval();
      this.getInsurce();
      setTimeout(() => {
        this.getNumberLetter();
      }, 1500);
    },

    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  created() {
    this.fillData();
    this.showContract();
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/ContratoExtras.vue